import PopupWrapper from './PopupWrapper';
import LineageWrapper from './LineageWrapper';
import EmbedPreview from 'app/home/tile/preview/EmbedPreview';
import AccessDeniedPopupWrapper from './AccessDeniedPopupWrapper';
import AppEditor from 'app/app/editor';
import RatingComponentWrapper from './RatingComponentWrapper';
import AppBuilderComponentWrapper from 'app/app/components';
import SearchWrapper from './SearchWrapper';
import GlossaryTermPopupWrapper from './GlossaryTermPopupWrapper';

export const COMPONENT_MAP: Record<string, (props: any) => JSX.Element> = {
    popup: (props) => <PopupWrapper props={props} />,
    lineage: (props) => <LineageWrapper props={props} />,
    preview: (props) => <EmbedPreview dataParams={props} />,
    access_denied_popup: (props) => <AccessDeniedPopupWrapper props={props} />,
    app_editor: (props) => <AppEditor props={props} />,
    feedback_prompt: (props) => <RatingComponentWrapper props={props} />,
    app_builder_component: (props) => <AppBuilderComponentWrapper props={props} />,
    search: (props) => <SearchWrapper props={props} />,
    glossary_term_popup: (props) => <GlossaryTermPopupWrapper props={props} />,
};

export default function SharedWrapper({ e }: { e: any }) {
    const Component = COMPONENT_MAP[e?.detail?.component];
    if (!Component) return null;

    return Component(e.detail.props);
}
